import { render, staticRenderFns } from "./ActitiveTabcomponent_mobile.vue?vue&type=template&id=46fb72a7&scoped=true"
import script from "./ActitiveTabcomponent_mobile.vue?vue&type=script&lang=js"
export * from "./ActitiveTabcomponent_mobile.vue?vue&type=script&lang=js"
import style0 from "./ActitiveTabcomponent_mobile.vue?vue&type=style&index=0&id=46fb72a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fb72a7",
  null
  
)

export default component.exports